import { render } from "./PointPage.vue?vue&type=template&id=1f041982"
import script from "./PointPage.vue?vue&type=script&lang=js"
export * from "./PointPage.vue?vue&type=script&lang=js"

import "./PointPage.vue?vue&type=style&index=0&id=1f041982&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__